import * as THREE from 'three';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls';

export default class SceneInit {
    constructor(canvasId) {
        // NOTE: Core components to initialize Three.js app.
        this.scene = undefined;
        this.camera = undefined;
        this.renderer = undefined;

        // NOTE: Camera params;
        this.canvasId = canvasId;

        // NOTE: Additional components.
        this.controls = undefined;

        // NOTE: Lighting is basically required.
        this.directionalLight = undefined;
    }

    initialize(width,height) {
        console.log("initialize")
        const canvas = document.getElementById(this.canvasId);
        canvas.width = width;
        canvas.height = height;
        this.renderer = new THREE.WebGLRenderer({
            canvas,
            // NOTE: Anti-aliasing smooths out the edges.
            antialias: true,
            alpha:true
        });
        this.renderer.setSize(canvas.width, canvas.height);
        // document.body.appendChild(this.renderer.domElement);

        this.scene = new THREE.Scene();
        // this.scene.background = new THREE.Color( 0xffff0000 );

        this.camera = new THREE.PerspectiveCamera(60, canvas.width / canvas.height, 0.1, 100);
        this.camera.position.set(2, 1, 2);
        this.camera.lookAt(this.scene.position);
        this.scene.add(this.camera);

        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.autoRotate = true;

        const light = new THREE.SpotLight(0xffffff, 1);
        light.position.set(1, 2, 5);
        //remove color
        light.encoding = THREE.sRGBEncoding;
        this.scene.add(light);

        // const light = new THREE.AmbientLight(0xffffff,0.6);
        // this.scene.add(light);

        // const light2 = new THREE.DirectionalLight(0x00ffff, 1);
        // light2.position.set(2, 1, 2);
        // this.scene.add(light2);

        // this.animate();
        window.addEventListener('resize', () => this.onWindowResize());
    }

    animate() {
        window.requestAnimationFrame(this.animate.bind(this));

        this.controls.update();

        this.renderer.render(this.scene, this.camera);
    }

    onWindowResize() {
        const width = window.innerWidth;
        const height = window.innerHeight;

        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(width, height);
    }

    destroy() {
        try {
            this.scene.clear();
            this.renderer.dispose();
            this.renderer.content = null;
            cancelAnimationFrame(this.animate);
            let gl = this.renderer.domElement.getContext("webgl");
            gl && gl.getExtension("WEBGL_lose_context").loseContext();
        } catch (e) {
            console.log(e)
        }
    }


}
